import { el } from 'redom';

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

import './index.scss';

class Timeline {

  constructor(videoBuilder) {

    this.videoBuilder = videoBuilder;

    this.el = el('.video-builder-timeline');

    noUiSlider.create(this.el, {
      start: 0,
      connect: 'lower',
      range: {
        min: 0,
        max: this.videoBuilder.playerProperties.durationInSeconds
      },
      step: 0.01,
      onChange: (values, userInteraction) => userInteraction && this.videoBuilder.seek(+values[0])
    });

    this.el.noUiSlider.on('change', (values, handle) => this.videoBuilder.seek(+values[0]));

  }

  onunmount() {

    this.el.noUiSlider.destroy();

  }

  update(timeElapsed) {

    this.el.noUiSlider.set([timeElapsed]);
    this.el.noUiSlider.updateOptions({
      start: timeElapsed,
      range: {
        min: 0,
        max: this.videoBuilder.playerProperties.durationInSeconds
      }
    }, false);

  }

}

export default Timeline;